<template>
  <div class="home-page">
    <Banner loc="1" :baseBtn="true"/>
    <NewProducts :adv="advList" />
    <div class="recommend">
      <CaptionBar :title="$t('home.caption')" sub-title="RECOMMEND" />
      <div class="goods-wrapper-h c-layout">
        <GoodsItem :item="item" v-for="(item,index) in recommendList" :key="index"  @addcart="handleOpenAddCartDrawer" />
      </div>
    </div>
    <Ad :ad-img="adv5" v-if="adv5"/>
    <GoodsFlexible :list="hotList" :title="$t('goodsFlexible.hot')" sub-title="HOT ITEM" tag="hot" />
    <Ad :ad-img="adv6" v-if="adv6"/>
    <GoodsFlexible :list="newList" :title="$t('goodsFlexible.new_arrival')" sub-title="NEW ARRIVALS" tag="new" />
    <GoodsStretch  :list="preferential" sub-title="preferential"/>
    <AddCartDrawer ref="drawer"/>
  </div>
</template>
<script>
import Banner from "@/components/Banner";
import NewProducts from "./components/NewProducts";
import GoodsFlexible from "@/components/GoodsFlexible";
import CaptionBar from "@/components/CaptionBar";
import GoodsItem from "@/components/GoodsItem";
import GoodsStretch from "@/components/GoodsStretch";
import adImg1 from "./images/01841_03.png";
import adImg1_mob from "./images/01841_03_mobile.png";
import adImg2 from "./images/01841_06.png";
import adImg2_mob from "./images/01841_06_mobile.png";
import Ad from "./components/Ad/response.vue";
import AddCartDrawer from '../../components/AddCardDrawer/index.vue'
import { getGoodsList,getPreferential,getHomeAdv,getHomeGoodsList } from "@/api";
export default {
  data() {
    return {
      pageSize: 6,
      adImg1: {
        pc: adImg1,
        mob: adImg1_mob
      },
      adImg2: {
        pc: adImg2,
        mob: adImg2_mob
      },
      recommendList: "",
      hotList: "",
      newList:"",
      preferential:"",
      adv5: '',
      adv6: '',
      advList: []
    };
  },
  mounted() {
    console.log(this.$t('alert_message')['to_edit_userinfo']);
    // this.getRecommendList();
    // this.getHotList();
    // this.getNewList();
    this.getTotalGoodsList();
    this.getAd();

    // getPreferential({preferential:12}).then(res=>{
    //    this.preferential  = res.preferential;
    // })
  },
  methods: {
    async getTotalGoodsList() {
      try {
        const { recommend, hot, new:newGoods, preferential } = await getHomeGoodsList();
        this.recommendList = recommend;
        this.hotList = hot;
        this.newList = newGoods;
        this.preferential  = preferential;
      } catch (error) {
        console.log('--- getHomeGoodsList error ---');
        console.log(error);
      }
    },
    async getRecommendList(data) {
      getGoodsList({ recommend: this.pageSize }).then((res) => {
        this.recommendList = res.recommend;
      });
    },
    async getHotList(data) {
      getGoodsList({ hot: 12 }).then((res) => {
        this.hotList = res.hot;
      });
    },
    async getNewList(data) {
      getGoodsList({ new: 12 }).then((res) => {
        this.newList = res.new;
      });
    },
    async getAd() {
      // const adv5 = await getHomeAdv({ loc: 'adv5', count: 1 });
      // const adv6 = await getHomeAdv({ loc: 'adv6', count: 1 });
      // this.adv5 = adv5.status==='ok'?adv5.adv[0]:'';
      // this.adv6 = adv6.status==='ok'?adv6.adv[0]:'';
      const adv = await getHomeAdv();
      console.log('getAD');
      console.log('adv',adv);
      this.advList = adv.adv;
      this.adv5 = adv.status==='ok'&& adv.adv[4] ? adv.adv[4]:'';
      this.adv6 = adv.status==='ok'&& adv.adv[5] ? adv.adv[5]:'';
    },
    async handleOpenAddCartDrawer(pid) {
      // this.choosePid = pid;
      this.$refs.drawer.handleOpenAddCartDrawer(pid);
    },
    // handleMoreHotData(){}
  },
  components: {
    Banner,
    NewProducts,
    GoodsFlexible,
    Ad,
    CaptionBar,
    GoodsItem,
    GoodsStretch,
    AddCartDrawer,
  },
};
</script>

<style  lang='less'>
.home-page {
  overflow: hidden;
  .goods-wrapper-h {
    display: flex;
    flex-wrap: wrap;
    padding-top: 48px;
    .goods-item-comp {
      width: 350px !important;
      margin-right: 30px !important;
      .goods-img {
        height: 440px !important;
      }
    }
    .goods-item-comp:nth-child(3n) {
      margin-right: 0px !important;
    }
  }
  @media (max-width: 992px) {
    .goods-wrapper-h {
      padding-top: 10px;
      .goods-item-comp {
        flex: 0 0 50%;
        margin-right: 0 !important;
        padding: 0 15px;
        .goods-img {
          height: unset !important;
          padding-top: calc(100%/153*191);
          position: relative;
          img {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
    .score {
      display: flex;
      justify-content: center;
    }
    .goods-name {
      text-align: center;
    }
    .goods-item__bottom {
      margin-bottom: 20px;
      color: var(---unnamed-color-707070);
      justify-content: center;
      .goods-price {
        font-size: 1.5rem;
        font-weight: 400;
      }
    }
  }
}
</style>